import { Col, Row } from "antd";
import { useEffect, useState,  } from "react";
import { getApis } from "../../../Common/apis";
import {
  fleetBasedVehicleModelsUrl,
  fleetsUrl,
} from "../../../Common/endpoints";
import FleetFilter from "./Filter";
import dataList from "./DataList.json";
import { BATTERY_STATUS } from "../../../Common/Grafana/Constants";
import { useDispatch, useSelector } from "react-redux";
import { getGrafanaBaseURL, grafanaDynamicSampling } from "../../../Common/Utils";
import GetIframe from "../../../Common/Grafana/GetIframe";
import { SmileOutlined } from "@ant-design/icons";
import { setPageLoader } from "../../../../reducers/loaderSlice";

const Fleet = () => {
  const dispatch = useDispatch();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const startTime = useSelector((state) => state.filter.startTime);
  const endTime = useSelector((state) => state.filter.endTime);
  const [fleetList, setFleetList] = useState([]);
  const [fleetId, setFleetId] = useState(null);
  const [modelList, setModelList] = useState([]);
  const [imeiList, setImeiList] = useState([]);
  const [model, setModel] = useState({});
  const authToken = localStorage.getItem("authToken");
  const [batteryField, setBatteryField] = useState("");

  const getFleets = async () => {
    await getApis(fleetsUrl, {}, authToken)
      .then((response) => {
        setFleetList(response?.data || []);
        setFleetId(response?.data[0]?.fleetId);
        if (response?.data?.length > 0) {
          getVehicleModels(response?.data[0]?.fleetId);
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch(setPageLoader(null));
      });
  };

  const getVehicleModels = async (fleetId) => {
    await getApis(fleetBasedVehicleModelsUrl, { fleetId: fleetId }, authToken)
      .then((response) => {
        setModelList(response?.data);
        setModel(response?.data[0]);
        setImeiList(response?.data[0]?.vehicles);
        dispatch(setPageLoader(null));
      })
      .catch((error) => {
        console.log(error);
        dispatch(setPageLoader(null));
      });
  };

  useEffect(() => {
    getFleets();
    setBatteryField(dataList?.battery[0]?.value);
    dispatch(setPageLoader("refresh"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeFleet = (value) => {
    setFleetId(value);
    getVehicleModels(value);
  };

  const onChangeModel = (value) => {
    const list = modelList.filter((item) => item.modelId === value);
    setModel(list[0]);
    setImeiList(list[0]?.vehicles);
  };

  const onSelectBattery = (value) => {
    setBatteryField(value);
  };

  const baseBatteryFilterObject = {
    orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
    batteryfield: batteryField,
    bucket_interval: grafanaDynamicSampling(startTime, endTime, 'battery', undefined, imeiList?.length),
    from: startTime,
    to: endTime,
    fleet_id: fleetId,
    model_id: model?.modelId,
    imei: "All",
  };

  return fleetList?.length > 0 ? (
    <div data-testid="fleet-component">
      <FleetFilter
        fleetList={fleetList}
        fleetId={fleetId}
        onChangeFleet={onChangeFleet}
        onSelectBattery={onSelectBattery}
        batteryField={batteryField}
        batteryList={dataList.battery}
        onChangeModel={onChangeModel}
        model={model}
        modelList={modelList}
      />
      <div className="card pd1 mt1">
        {imeiList?.length > 0 && (
          <Row gutter={[16, 16]} className="pd0">
            <Col xs={24} sm={24} md={24} lg={12} xl={12} id="avg-post-iframe">
              <GetIframe
                title={"Histogram - Averages"}
                url={getGrafanaBaseURL(
                  BATTERY_STATUS.FLEET.DASHBOARD_ID,
                  BATTERY_STATUS.FLEET.DASHBOARD_NAME
                )}
                panelId={
                  BATTERY_STATUS.FLEET.PANEL_ID["genericData"]["avgHistogram"]
                }
                variableObject={baseBatteryFilterObject}
                variableKeys={BATTERY_STATUS.FLEET.BASE_VARIABLES}
                width="100%"
                height="290"
                divId="avg-post-iframe"
              />
            </Col>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={12}
              xl={12}
              id="median-post-iframe"
            >
              <GetIframe
                title={"Histogram - Averages"}
                url={getGrafanaBaseURL(
                  BATTERY_STATUS.FLEET.DASHBOARD_ID,
                  BATTERY_STATUS.FLEET.DASHBOARD_NAME
                )}
                panelId={
                  BATTERY_STATUS.FLEET.PANEL_ID["genericData"][
                    "medianHistogram"
                  ]
                }
                variableObject={baseBatteryFilterObject}
                variableKeys={BATTERY_STATUS.FLEET.BASE_VARIABLES}
                width="100%"
                height="290"
                divId="median-post-iframe"
              />
            </Col>
          </Row>
        )}
      </div>
    </div>
  ) : fleetList ? (
    <div data-testid="no-fleet-component">
      <Row justify="center" align={"middle"} className="w100 hv25 flex-center">
        <Col span={24} className="text-center">
          <div>
            <SmileOutlined
              className="icon-font32 mb05 text-center"
              style={{ color: "#667085" }}
            />
          </div>
          <div className="grey f13">No Fleet</div>
        </Col>
      </Row>
    </div>
  ) : null;
};

export default Fleet;
